/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Home.css';
import Particles from 'react-particles-js';
import banner from './banner.svg';
import customization from './Customization.png';
import dashboard from './Dashboard.png';
import footbanner from './footBanner.png';
import mindshare from './Mindshare.png';
// import today from './todayBg.png';
import cx from 'classnames';
import Link from './../../components/Link'
import Homerank from './../../components/Homerank';
import FloatLogin from './../../components/Floatlogin'
import Model from './../../components/Model'
import HomeBanner from './../../components/HomeBanner'


import BannerAnim, { Element } from 'rc-banner-anim';
import TweenOne from 'rc-tween-one';
import animCss from 'rc-banner-anim/assets/index.css';
const BgElement = Element.BgElement;


class Home extends React.Component {
  static propTypes = {
   
  };

  constructor(){
    super()
    this.state={
      isShowFloatLogin:false,
      isShowModel:false,
      isLoginUser:false
    }
    this.changeShow=this.changeShow.bind(this)
    this.close=this.close.bind(this)
    this.closeModel=this.closeModel.bind(this)
  }

  componentDidMount() {
    
    if(window.localStorage.getItem('isLogin')){
        this.setState({
          isLoginUser:true,

        })
      
    }else{
      localStorage.setItem('isLogin','false')
      this.setState({
        isLoginUser:false,

      })
    }
    
  }
  closeModel=()=>{
    
    
    this.setState({isShowModel:false})
    
  }
  changeShow(){
    // this.setState({isShowFloatLogin:true})
    if(window.localStorage.getItem('isLogin')=='true'){

      this.setState({isShowModel:true})
    }else{
      this.setState({isShowFloatLogin:true})
    }
  
  }
  close=()=>{
    this.setState({isShowModel:false,isShowFloatLogin:false})
  }

  render() {
    // console.log(this.state.isLoginUser,this.state.isShowFloatLogin,this.state.isShowModel)
    const {isShowFloatLogin}=this.state

    return (
      <div className={s.root}>

        
        <div className={s.homeBg}>
          <HomeBanner changeShow={this.changeShow} />
         
        </div>
        
        <div className={s.content}>
          
          <div className={s.dbRank}>
            <div className={s.dbTit}>
              <h3 className={s.h3Tit}>数字品牌榜</h3>
              <span className={s.h3EnTit}>Digital Brand Rank</span>
              <span className={s.h3Int}>计算品牌在社交媒体时代数字价值的三大维度：传播度，衡量信息扩散效率的指标；参与度，衡量受众卷入程度的指标；好感度，衡量受众情感倾向的指标</span>
              <Link to='/algorithm' className={s.h3color}>DBRank算法介绍</Link>
            </div>
          </div>

          
          <Homerank />
        </div>

        <div className={s.toDay}>

          <div className={s.toDayT}>
            <h3 className={cx(s.toDayTit, s.h3Tit)}>今日热点</h3>
            <span className={cx(s.toDayEn, s.h3EnTit)}>Headline</span>
          </div>
          <div className={s.toDayB}>
            <h2 className={s.toDayH2} onClick={()=>window.open('https://dbrank.net/static/pdf/DBRank100for2017.pdf')}>DBRank100：2017数字品牌价值100强年报</h2>
          </div>

        </div>
        <div className={cx(s.service, s.content)}>
          <div className={s.dbTit}>

            <h3 className={s.h3Tit}>解决方案</h3>
            <span className={s.h3EnTit}>Case & Solutions</span>
            {/* <span className={s.h3Int}>快速、清晰、直观地掌握你与竞品在社交媒体战场上的真实状况，动态反映受众情绪变化之因果</span> */}
            <span className={s.h3Int}>快速、清晰、直观地掌握你与竞品在社交媒体战场上的真实状况，动态反映受众情绪变化之因果</span>
            
          </div>
          <ul className={s.serItem}>
            <li className={s.itemList}>
              <i className={s.itemImg}></i>
              <span className={s.bar}>Dashboard</span>
              <span className={s.itemName}>品牌军情室</span>
              <span className={s.itemInt}>识别品牌自身在社交平台上的受众口碑真实状况，查看传播战役实际战果，发现关键事件和KOL</span>
              <Link to='/dashboard'  className={cx(s.moreBtn, s.serBtn)}>立即试用</Link>
            </li>
            <li className={s.itemList}>
              <i className={s.itemImg2}></i>
              <span className={s.bar}>Mindshare</span>
              <span className={s.itemName}>心智占有率</span>
              <span className={s.itemInt}>直观呈现品牌在细分领域中的受众心智占有份额；支持自由选择添加竞品进行比较</span>
              <div onClick={()=>{
                  localStorage.setItem('isBattle',null)
                }}>
                <Link to='/dashboard?brandName=demo' className={cx(s.moreBtn, s.serBtn)}>立即试用</Link>
              </div>
            </li>
            <li className={s.itemList}>
              <i className={s.itemImg3}></i>
              <span className={s.bar}>Customization</span>
              <span className={s.itemName}>定制化服务</span>
              <span className={s.itemInt}>满足您对特定时段、特定事件、特定需求的定制化数据服务， Contact us！</span>
              <span  className={cx(s.serBtn, s.moreBtn)} onClick={this.changeShow} >立即试用</span>
            </li>
          </ul>
        </div>

        <div className={s.footBanner}>
          <img src={footbanner}/>
        </div>
        <div className={cx(s.about, s.content)}>
          <div className={s.dbTit}>

            <h3 className={s.h3Tit}>关于DBRank</h3>
            <span className={s.h3EnTit}>About Us</span>
            <span className={s.h3Int}>数字品牌榜，社交媒体时代的用户口碑评价排行榜</span>
          </div>
          <span className={s.aboutTxt}>我们是一家传播科技（Communication Technology）公司，运用大数据+机器学习技术，打造传播领域的SaaS服务平台，</span>
          <span className={s.aboutTxt}>为企业公关、广告、市场、营销和运营提供基于社交媒体大数据的传播决策服务，识别战场状况，提高心智占有率，</span>
          <span className={s.aboutTxt}>计算品牌在数据时代的数字资产价值。</span>


        </div>
          {
            isShowFloatLogin?<FloatLogin show={this.state.isShowFloatLogin} up={true} isLogin={false} close={this.close}/>:null
          }
          <Model isShow={this.state.isShowModel} close={this.closeModel}/>
      </div>

    );
  }
}

export default withStyles(s,animCss)(Home);


// WEBPACK FOOTER //
// src/routes/home/Home.js